export const clearFormState = (formState) => {
    for (const key in formState) {
        if (Array.isArray(formState[key])) {
            formState[key] = [];
        } else if (typeof formState[key] === 'string') {
            formState[key] = '';
        } else {
            formState[key] = null;
        }
    }
}

export const formatTimeOnSite = (avgTime) => {
    const avgTimeOnSite = Number(avgTime);
    if (typeof avgTimeOnSite !== 'number' || avgTimeOnSite < 0) {
        throw new Error('avgTimeOnSite 必须是一个非负数字');
    }
    const hours = Math.floor(avgTimeOnSite / 3600);
    const minutes = Math.floor((avgTimeOnSite % 3600) / 60);
    const seconds = avgTimeOnSite % 60;
    if (hours > 0) {
        // 如果小时数大于0，则显示小时、分钟和秒
        return `${String(hours).padStart(2, '0')}时${String(minutes).padStart(2, '0')}分${String(seconds).padStart(2, '0')}秒`;
    } else {
        // 如果小时数为0，则只显示分钟和秒
        return `${String(minutes).padStart(2, '0')}分${String(seconds).padStart(2, '0')}秒`;
    }
}


export const parseTimeStringToSeconds = (timeString) => {
    // 正则表达式匹配时间字符串中的小时、分钟和秒
    const regex = /(?:(\d+)时)?(?:(\d+)分)?(\d+)秒/;
    const match = timeString.match(regex);

    if (!match) {
        throw new Error('时间格式不正确');
    }

    // 提取并解析小时、分钟和秒
    const hours = (match[1] ? parseInt(match[1], 10) : 0);
    const minutes = (match[2] ? parseInt(match[2], 10) : 0);
    const seconds = parseInt(match[3], 10);

    // 计算总秒数
    return hours * 3600 + minutes * 60 + seconds;
}

export const cleanAndReplaceAlias = (alias) => {
    let cleanedAlias = alias.toLowerCase();
    cleanedAlias = cleanedAlias.replace(/\s+/g, '-');
    cleanedAlias = cleanedAlias.replace(/[^a-zA-Z0-9-/\u4e00-\u9fff]+/g, '');
    cleanedAlias = cleanedAlias.replace(/-+/g, '-');
    cleanedAlias = cleanedAlias.replace(/^-|-$/g, '');
    return cleanedAlias;
}

// 封装方法  案例: '1,2,3'  [treedata树形结构数据] =>输出结果[{value: item.id, label: item.name},...] 最终方案（兼顾可读性和性能）
export function findObjects(data, ids) {
    const idSet = new Set(ids);
    const results = [];
    const stack = [...data];

    while (stack.length) {
        const { id, name, childlist } = stack.pop();
        if (idSet.has(id)) results.push({ value: id, label: name });
        if (childlist?.length) stack.push(...childlist);
    }
    return results;
}

// 封装方法  案例: '1,2,3'  [treedata树形结构数据] =>输出结果'name,name2...'

export function getNames(treeData, idList) {
    if (!treeData || !idList) return '';
    const ids = String(idList)
        .split(',')
        .map(id => id.trim())
        .filter(Boolean);
    if (ids.length === 0) return '';

    const idToNameMap = {};
    function buildMap(nodes) {
        nodes.forEach(node => {
            const key = String(node.id);
            idToNameMap[key] = node.name;
            if (node.childlist && Array.isArray(node.childlist)) {
                buildMap(node.childlist);
            }
        });
    }
    buildMap(treeData);

    const names = ids.map(id => idToNameMap[id] || '');
    return names.filter(Boolean).join(',');
}


export function replaceNullWithEmptyString(array) {
    return array.map((obj) => {
        if ("value" in obj && obj.value === null) {
            return { ...obj, value: "" };
        }
        return obj;
    });
}

export function processData(data) {
    if(data.length === 0) return;
    return data.map(item => {
        // 1. 提取日期键并按时间排序
        const sortedDates = Object.keys(item).sort();
        const newObj = {};
        
        // 2. 遍历每个日期，用前面的有效值填充后面的'--'
        sortedDates.forEach((date, currentIndex) => {
            const originalValue = item[date];
            
            // 非'--'值直接保留
            if (originalValue !== '--') {
                newObj[date] = originalValue;
            } else {
                // 对于'--'，只在前面寻找有效值
                let foundValidValue = null;
                
                // 从当前日期往前找（只找过去的数据）
                for (let i = currentIndex - 1; i >= 0; i--) {
                    const prevDate = sortedDates[i];
                    const prevValue = item[prevDate];
                    
                    if (prevValue !== '--') {
                        const numValue = Number(prevValue);
                        // 检查是否为有效的数字且小于40
                        if (!isNaN(numValue) && numValue < 40) {
                            foundValidValue = numValue;
                            break;
                        }
                    }
                }

                // 如果找到了前面的有效值，则替换当前的'--'
                if (foundValidValue !== null) {
                    newObj[date] = foundValidValue;
                } else {
                    // 没找到则保留'--'
                    newObj[date] = '--';
                }
            }
        });

        return newObj;
    });
}
export const getAllChildIds = (node) => {
    let ids = [];
    if (node.childlist && node.childlist.length) {
        node.childlist.forEach(child => {
            ids.push({ 'label': child.name, 'value': child.id });
            if (child.childlist) {
                ids = [...ids, ...getAllChildIds(child)];
            }
        });
    }
    return ids;
};

// 辅助函数：递归获取所有子节点的id

export const flattenChildrenKeys = (childlist) => {
    return childlist.reduce((keys, child) => {
        keys.push(child.id);
        if (child.childlist && child.childlist.length > 0) {
            keys = keys.concat(flattenChildrenKeys(child.childlist));
        }
        return keys;
    }, []);
};
export function findNode(menuData, targetId) {
    for (const item of menuData) {
        // 检查当前项
        if (item.id === targetId) {
            return item;
        }
        // 递归检查子项
        if (item.children?.length) {
            const found = findNode(item.children, targetId);
            if (found) return found;
        }
    }
    return null;
}
export function addNamesToTabs(tabsList, menuData) {
    return tabsList.map(tab => {
        // 只处理数字类型的 id
        if (typeof tab.id !== 'number') return tab;
        // 在树形数据中查找匹配项
        const matched = findNode(menuData, tab.id);
        // 没有匹配项时直接返回原对象
        if (!matched) return tab;
        // 创建新对象（避免直接修改原对象）
        const newTab = { ...tab };
        // 添加/更新 name 属性
        if (matched.name) {
            newTab.name = matched.name;
        }
        // 检查 menu_type 是否为 2
        if (matched.menu_type === 2) {
            newTab.menu_type = 2;
        }
        return newTab;
    });
}

export function processArray(arr) {
    // 确保输入是字符串时才进行分割，否则直接使用数组
    let data = Array.isArray(arr) ? arr : (arr ? arr.split('/') : []);
    return data.filter(item => {
        // 排除空字符串
        if (item === '') return false;
        // 排除数字类型（包括字符串形式的数字）
        if (!isNaN(Number(item)) && typeof item !== 'boolean') return false;
        return true;
    });
}


function getBasePath(path) {
    // 分割路径并过滤空字符串，取第一个有效部分
    const pathParts = path.split('/').filter(part => part.trim() !== '');
    return pathParts.length > 0 ? pathParts[0] : '';
}

export function replaceMatchedRoute(data1, object1) {
    // 复制原数组避免直接修改源数据（可选操作，根据实际需求）
    const newData = [...data1];
    object1.id=object1.name
    // 提取object1的基础路径和menu_type
    const targetBasePath = getBasePath(object1.path);
    const targetMenuType = object1.menu_type;

    // 遍历查找符合条件的元素
    for (let i = 0; i < newData.length; i++) {
        const item = newData[i];

        // 条件1：menu_type都为2且相等
        const isMenuTypeMatch = item.menu_type === targetMenuType && targetMenuType === 2;

        // 条件2：基础路径部分相同
        const itemBasePath = getBasePath(item.path);
        const isBasePathMatch = itemBasePath === targetBasePath;

        // 两个条件都满足则替换
        if (isMenuTypeMatch && isBasePathMatch) {
            newData[i] = { ...object1 }; // 用新对象覆盖旧对象
            break; // 找到第一个匹配项后退出循环，如需替换所有匹配项可移除break
        }
    }
    return newData;
}
export function checkRouteMatch(data1, object1) {
    // 提取object1的基础路径和menu_type
    const targetBasePath = getBasePath(object1.path);
    const targetMenuType = object1.menu_type;
    
    // 首先检查object1的menu_type是否为2，不满足则直接返回false
    if (targetMenuType !== 2) {
      return false;
    }
    
    // 遍历data1查找是否有符合条件的对象
    for (const item of data1) {
      // 条件1：menu_type都为2且相等
      const isMenuTypeMatch = item.menu_type === targetMenuType;
      
      // 条件2：基础路径部分相同
      const itemBasePath = getBasePath(item.path);
      const isBasePathMatch = itemBasePath === targetBasePath;
      
      // 两个条件都满足则返回true
      if (isMenuTypeMatch && isBasePathMatch) {
        return true;
      }
    }
    
    // 没有找到符合条件的对象
    return false;
  }